import { Helmet } from 'react-helmet-async'
import { site } from '@/content/site'
import { getSiteUrl } from '@/lib/siteUrl'

const baseUrl = getSiteUrl()

/** Placeholder NAP — swap before launch; aligns with LocalBusiness schema */
export function LocalBusinessJsonLd() {
  const sameAs = Object.values(site.social)

  const data = {
    '@context': 'https://schema.org',
    '@type': 'BeautySalon',
    name: site.name,
    description: site.tagline,
    image: `${baseUrl}/2.jpg`,
    telephone: site.phoneE164,
    email: site.email,
    address: {
      '@type': 'PostalAddress',
      streetAddress: site.streetAddress,
      addressLocality: site.addressLocality,
      addressRegion: site.addressRegion,
      postalCode: site.postalCode,
      addressCountry: 'US',
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        opens: '10:00',
        closes: '19:00',
      },
    ],
    sameAs,
    url: baseUrl,
  }

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  )
}
